export const FEATURES = {
  SIMULATIONS: true,
  JOB_MANAGEMENT: false,
  VIDEO_INTERVIEWS: false,
  CANDIDATE_SCREENING: false,
  CANDIDATE_REPORTS: false,
} as const;

